import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './design.css';
import './NewRestaurantSummary.css'
import App from './App';
import firebase from 'firebase/app'
import 'firebase/analytics'
import registerServiceWorker from './registerServiceWorker';
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './store/reducers/rootReducer'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createFirestoreInstance, reduxFirestore } from 'redux-firestore';
import { ReactReduxFirebaseProvider, getFirebase } from 'react-redux-firebase';
import fbConfig from './config/fbConfig'


const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({trace: true, tracelimit:20}) : compose;
const store = createStore(rootReducer,
  composeEnhancers(
    applyMiddleware(thunk.withExtraArgument({getFirebase})),
    reduxFirestore(fbConfig)
  )
);

const rrfProps = {
   firebase,
   config: fbConfig,
   dispatch: store.dispatch,
   createFirestoreInstance // <- needed if using firestore
 }

firebase.analytics();

ReactDOM.render(<Provider store={store}>
	<ReactReduxFirebaseProvider {...rrfProps}>
	<App />
	</ReactReduxFirebaseProvider>
	</Provider>, document.getElementById('root'));
//registerServiceWorker();


